export const getCurrentBrowser = () => {
  const userAgent = navigator.userAgent;
  const isOpera = userAgent.indexOf("Opera") > -1;
  const isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera;
  const isEdge = userAgent.indexOf("Edg") > -1 && !isIE;
  const isFF = userAgent.indexOf("Firefox") > -1;
  const isSafari = userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1;
  const isChrome = userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1;

  if (isIE) {
    return "IE";
  }
  if (isEdge) {
    return "Edge";
  }
  if (isFF) {
    return "Firefox";
  }
  if (isSafari) {
    return "Safari";
  }
  if (isChrome) {
    return "Chrome";
  }
  return "unknown";
};
